import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { DownloadIcon } from 'lucide-react';
const steps = [{
  number: '01',
  title: 'Descargas el material y realizas la lectura individual del Capítulo 1 y 2.'
}, {
  number: '02',
  title: 'Acuerdas con tu pareja el momento para el primer "Tablero Logístico".'
}, {
  number: '03',
  title: 'Firman el Contrato de Convivencia y aplican el Plan S.O.S de Emergencia la próxima vez que el ambiente se tense.'
}];
export function HowItWorksSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-20 md:py-28 bg-[#FFFFFF]" data-id="element-129">
      <div className="max-w-3xl mx-auto px-6" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-131">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2D2D] mb-16 text-center" data-id="element-132">
            Cómo funciona:
          </h2>

          <div className="relative" data-id="element-133">
            {/* Vertical connecting line */}
            <div className="absolute left-8 top-8 bottom-8 w-0.5 bg-black/10 hidden md:block" data-id="element-134"></div>

            <div className="space-y-12" data-id="element-135">
              {steps.map((step, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} animate={isInView ? {
              opacity: 1,
              y: 0
            } : {
              opacity: 0,
              y: 20
            }} transition={{
              duration: 0.5,
              delay: index * 0.15
            }} className="flex flex-col md:flex-row gap-6 md:gap-8 items-start relative z-10" data-id="element-136">
                  <div className="w-16 h-16 bg-[#722F37] text-white rounded-full flex items-center justify-center flex-shrink-0 text-2xl font-bold shadow-[0_0_20px_rgba(114,47,55,0.3)] ring-4 ring-[#FFFFFF]" data-id="element-137">
                    {step.number}
                  </div>
                  <div className="flex-1 pt-3 bg-[#F0EDEB] p-6 rounded-xl border border-black/5 shadow-md w-full" data-id="element-138">
                    <p className="text-lg md:text-xl text-[#2D2D2D] leading-relaxed" data-id="element-139">
                      {step.title}
                    </p>
                  </div>
                </motion.div>)}
            </div>

            {/* Delivery Clarity Box */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.5,
            delay: 0.6
          }} className="mt-12 bg-[#059669]/10 border border-[#059669]/30 rounded-xl p-6 flex flex-col sm:flex-row items-center gap-4 text-center sm:text-left relative z-10" data-id="element-140">
              <div className="w-12 h-12 bg-[#059669]/20 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-141">
                <DownloadIcon className="w-6 h-6 text-[#059669]" data-id="element-142" />
              </div>
              <p className="text-[#2D2D2D] font-semibold text-lg" data-id="element-143">
                Acceso inmediato tras el pago: Recibirás un archivo PDF
                descargable compatible con cualquier dispositivo.
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}